module.exports = "<svg id=\"82395ec8-ba62-4d36-9b22-230096a99282\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>check</title><polygon points=\"14.53 37.44 4.13 16.82 0 20 13.78 46.28 49.87 7.91 46.33 4 14.53 37.44\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/check.svg
// module id = 553
// module chunks = 1